module.exports = __webpack_public_path__ + "img/kudos.58c67268.png";